import { render, staticRenderFns } from "./CustomerName.vue?vue&type=template&id=22fa269f"
import script from "./CustomerName.vue?vue&type=script&lang=js"
export * from "./CustomerName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22fa269f')) {
      api.createRecord('22fa269f', component.options)
    } else {
      api.reload('22fa269f', component.options)
    }
    module.hot.accept("./CustomerName.vue?vue&type=template&id=22fa269f", function () {
      api.rerender('22fa269f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/CustomerName.vue"
export default component.exports